export default __webpack_public_path__ + "static/media/netlify.63d286a9.png";